import React from "react";

const SplitBillIntoEqualPayments = () => {
  return <div>SplitBillIntoEqualPayments</div>;
};

export default SplitBillIntoEqualPayments;
